import { useContext, useEffect, useState } from 'react'
import { PromotedBranchContext } from '../context/context'

import RadioButton from '../../common/RadioButton'
import InputText from '../../common/InputText'
import { getRequest } from '../../../services/base'
import Tooltip from '../../common/tooltip'
import useDebouncedValue from '../../../utils/common_function'
import NoRecordsFound from '../../common/NoRecordsFound'
import { CheckboxMinus, CheckCircle } from '@styled-icons/boxicons-solid'

const PreviewPromotedFiles = ({ selectedRow }) => {
  const [state, dispatch] = useContext(PromotedBranchContext)

  const [section, setSection] = useState(null)
  const [sectionData, setSectionData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchValue, setSearchValue] = useState(null)
  const debouncedToSearchValue = useDebouncedValue(searchValue, 500)

  useEffect(() => {
    getMakeModalFileDetails()
  }, [])

  useEffect(() => {
    if (searchValue) {
      setFilteredData(
        sectionData.filter((item) =>
          item.file_name.toLowerCase().includes(searchValue?.toLowerCase())
        )
      )
    } else {
      setFilteredData([...sectionData])
    }
  }, [sectionData, debouncedToSearchValue])

  const getMakeModalFileDetails = async () => {
    let res = await getRequest(
      `/api/promote_changes/promoted-files/${selectedRow?.value?.vehicle_id}/`
    )
    dispatch({
      type: 'set_selected_files',
      data: {
        promoted_folder_data: res?.folder_data,
        promoted_file_data: res?.promoted_file_data,
        customer_files: res?.customer_files,
      },
    })
  }

  return (
    <>
      <div className="flex flex-row flex-wrap text-black text-lg">
        {state?.selectedFiles?.promoted_file_data?.length < 1 &&
          state?.selectedFiles?.promoted_folder_data?.connector_views?.length <
            1 &&
          state?.selectedFiles?.promoted_folder_data.power_distribution
            ?.length < 1 &&
          state?.selectedFiles?.promoted_folder_data.vehicle_views?.length <
            1 &&
          state?.selectedFiles?.customer_files?.length < 1 && (
            <div className="text-lg text-center w-full text-sm">
              Files or Folders not selected.
            </div>
          )}

        {state?.selectedFiles?.customer_files?.length > 0 && (
          <div className="py-2 text-lg border-b border-white w-full">
            <div className="flex items-center justify-between">
              <div>Customer Setup :- </div>
            </div>
            <div className="flex flex-row flex-wrap">
              {state?.selectedFiles?.customer_files &&
                state?.selectedFiles?.customer_files?.map(
                  (fileObj, fileIdx) => {
                    return (
                      <div
                        className="flex w-1/4 py-1"
                        key={`customer-file-${fileObj.file_name}-${fileIdx}`}
                      >
                        <div className={`px-2 flex items-center w-full`}>
                          <>
                            <div className="table_text w-auto text-black">
                              <Tooltip message={fileObj.file_name}>
                                <span className="px-2 w-full">
                                  {fileObj.file_name}
                                </span>
                              </Tooltip>
                            </div>
                          </>
                        </div>
                      </div>
                    )
                  }
                )}
            </div>
          </div>
        )}

        {state?.selectedFiles?.promoted_file_data?.length > 0 && (
          <div className="py-2 text-lg border-b border-white w-full">
            <div className="flex items-center justify-between">
              <div>Make Model Files :-</div>
            </div>
            <div className="flex flex-row flex-wrap">
              {state?.selectedFiles?.promoted_file_data?.length > 0 ? (
                state?.selectedFiles?.promoted_file_data?.map(
                  (fileObj, fileIdx) => {
                    return (
                      <div
                        className="flex w-1/4 py-1"
                        key={`files-${fileObj.file_name}-${fileIdx}`}
                      >
                        <div className={`px-2 flex items-center w-full`}>
                          <>
                            <div className="table_text w-auto text-black">
                              <Tooltip message={fileObj.file_name}>
                                <span className="px-2 w-full">
                                  {fileObj.file_name}
                                </span>
                              </Tooltip>
                            </div>
                          </>
                        </div>
                      </div>
                    )
                  }
                )
              ) : (
                <NoRecordsFound />
              )}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-row flex-wrap text-black text-lg w-full">
        {state?.selectedFiles?.promoted_folder_data &&
          Object.keys(state?.selectedFiles?.promoted_folder_data)?.map(
            (key, vehicleIdx) => {
              return state?.selectedFiles?.promoted_folder_data[key]?.length >
                0 ? (
                <div className="flex w-auto py-1" key={`vehicle-${key}`}>
                  <div className="px-2 flex items-center w-full">
                    <RadioButton
                      name={'section'}
                      checked={section === key}
                      onChange={(e) => {
                        if (e?.target?.checked) {
                          setSection(key)
                          setSectionData([
                            ...state?.selectedFiles?.promoted_folder_data[key],
                          ])
                        } else {
                          setSection(null)
                          setSectionData([])
                        }
                      }}
                    />
                    <span
                      className="px-2 cursor-pointer"
                      onClick={() => {
                        if (key === section) {
                          setSection(null)
                          setSectionData([])
                        } else {
                          setSection(key)
                          setSectionData([
                            ...state?.selectedFiles?.promoted_folder_data[key],
                          ])
                        }
                      }}
                    >
                      {key}
                    </span>

                    {key === 'connector_views' && (
                      <div className={`flex items-center text-black`}>
                        [
                        <div className="flex items-center px-2">
                          {selectedRow?.value?.include_pn ? (
                            <CheckCircle
                              size="1rem"
                              color="text-green-700"
                              className="text-green-700"
                            />
                          ) : (
                            <CheckboxMinus
                              size="1rem"
                              color="text-red-700"
                              className="text-red-700"
                            />
                          )}

                          <div className="table_text w-auto">
                            <Tooltip message={`Include Part Number`}>
                              <span className="px-2">Included Part Number</span>
                            </Tooltip>
                          </div>
                        </div>
                        ]
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )
            }
          )}
      </div>

      {section && (
        <div>
          <div className="border-b border-t border-black my-3 bg-tracer-darkest-blue">
            <div className="flex justify-between items-center text-white mx-2">
              <div className="flex w-full justify-start items-center gap-3">
                <div>View {section} files from here</div>
              </div>

              <InputText
                name="search_value"
                placeholder={`Search ${section} ....`}
                className={`w-auto`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
              <span
                className="text-3xl cursor-pointer"
                onClick={() => {
                  setSection(null)
                }}
              >
                &times;
              </span>
            </div>
          </div>
          <div
            className="relative overflow-y-scroll "
            style={{ maxHeight: '60vh' }}
          >
            <div className="flex flex-row flex-wrap  text-base ">
              {filteredData
                .sort()
                .slice(0, filteredData?.length)
                .map((filterObj, sectionIdx) => {
                  return (
                    <div
                      className="flex w-1/4 py-1"
                      key={`section-${filterObj.file_name}`}
                    >
                      <div className="px-2 flex items-center w-full">
                        <div className="table_text w-3/4">
                          <Tooltip message={filterObj.file_name}>
                            <span className="px-2 w-full">
                              {filterObj.file_name}
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div>

            {sectionData?.length === 0 && <NoRecordsFound />}
          </div>
        </div>
      )}
    </>
  )
}

export default PreviewPromotedFiles
